import urlTemplate from 'url-template'

export default
  isLoaded: (state) ->
    state.is_loaded

  getHref: (state) ->
    (ref) ->
      state.endpoints.getLink(ref).href

  getURLTemplate: (state) ->
    (ref) ->
      urlTemplate.parse state.endpoints.getLink(ref).href

  resourceURL: (state) ->
    (type) ->
      try
        state.resources.getLink(type).href
      catch
        throw 'Resource of type: "' + type + '" doesn\'t exist!'



// WEBPACK FOOTER //
// ./src/vuex/getters.coffee